import { useEffect, useState } from "react";
import CommonModal from "../components/CommonModal";
import { Spinner } from "react-bootstrap";
import SectionsTabs from "./pages/SectionsTabs";
import { requestWithToken } from "../utils/apis";
import cross from "../assets/black-cross.svg";
export default function SelectTemplateOrSectionModal({
    show,
    onClose,
    onInsert
}) {
    const [activeTab, setActiveTab] = useState("templates");
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchList = async () => {
        setLoading(true);
        try {
            let endpoint = "";

            if (activeTab === "templates") {
                endpoint = "/api/sectionType/list?page=1&limit=50&sort=label&order=asc";
            } else {
                endpoint =
                    endpoint = "/api/section/list?page=1&limit=50&is_template=true";
            }

            const response = await requestWithToken("GET", endpoint);

            if (response?.status === 200) {
                setItems(response.data.data.list || []);
            } else {
                setItems([]);
            }
        } catch (err) {
            setItems([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show) {
            fetchList();
        }
    }, [show, activeTab]);

    return (
        <CommonModal show={show} onClose={onClose} width="60vw" height="60vh">

            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
                Insert Template or Section <img src={cross} alt="icon" className="pointer" onClick={onClose} />
            </div>
            <SectionsTabs activeTab={activeTab} setActiveTab={setActiveTab} />

            {loading ? (
                <div className="text-center p-4">
                    <Spinner />
                </div>
            ) : items.length === 0 ? (
                <div className="text-center p-5">No {activeTab} available.</div>
            ) : (
                <div className="scroll-y">
                    <div className="table-responsive">
                        <table className="pages-table">
                            <thead>
                                <tr>
                                    <th>Section Name</th>
                                    <th>Date Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                            {items.map((item) => {
                                    const label =
                                        activeTab === "templates"
                                            ? item.label   // sectionType → label is root-level
                                            : item?.section_type_id?.label || item.label;

                                    const createdAt =
                                        activeTab === "templates"
                                            ? item?.createdAt
                                            : item?.createdAt;

                                    return (
                                        <tr key={item._id}>
                                            <td>{label || "-"}</td>
                                            <td>{new Date(createdAt).toLocaleDateString()}</td>

                                            <td>
                                                <span
                                                    className="insert-button pointer"
                                                    onClick={() => {
                                                        onInsert(item, activeTab);
                                                        onClose();
                                                    }}
                                                >
                                                    Insert
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            )}
        </CommonModal>
    );
}
